import { CharacteristicsResourceApi, EmployeeGroupDTO, GetCharacteristic200Response, GroupsResourceApi } from '@root/api';
import { errorService } from './newError.service';

let groupsCache: EmployeeGroupDTO[] | null = null;
let groupsPrefetchPromise: Promise<EmployeeGroupDTO[]> | null = null;

let characteristicsCache: GetCharacteristic200Response[] | null = null;
let characteristicsPrefetchPromise: Promise<GetCharacteristic200Response[]> | null = null;

export const getGroupsCached = (active = true): Promise<EmployeeGroupDTO[]> => {
    if (groupsCache) {
        return Promise.resolve(groupsCache);
    }

    if (!groupsPrefetchPromise) {
        groupsPrefetchPromise = new GroupsResourceApi()
            .getGroups(active)
            .then((response) => {
                groupsCache = response.data ?? [];
                return groupsCache;
            })
            .catch((error) => {
                groupsPrefetchPromise = null;
                errorService.reportError(error);
                throw error;
            });
    }

    return groupsPrefetchPromise;
};

export const prefetchGroups = (): void => {
    void getGroupsCached(true).catch(() => undefined);
};

export const getCompanyCharacteristicsCached = (): Promise<GetCharacteristic200Response[]> => {
    if (characteristicsCache) {
        return Promise.resolve(characteristicsCache);
    }

    if (!characteristicsPrefetchPromise) {
        characteristicsPrefetchPromise = new CharacteristicsResourceApi()
            .getCompanyCharacteristics()
            .then((response) => {
                characteristicsCache = response.data ?? [];
                return characteristicsCache;
            })
            .catch((error) => {
                characteristicsPrefetchPromise = null;
                errorService.reportError(error);
                throw error;
            });
    }

    return characteristicsPrefetchPromise;
};

export const prefetchCharacteristics = (): void => {
    void getCompanyCharacteristicsCached().catch(() => undefined);
};

export const startSegmentationPrefetch = (): void => {
    prefetchGroups();
    prefetchCharacteristics();
};
